<template>
  <ValidationProvider
    :vid="fieldId"
    :name="fieldId"
    class="form-group"
    tag="div"
    v-slot="v"
  >
    <div class="col-sm-2 label-field">
      <label class="control-label" :for="fieldId">
        {{ name }}
      </label>
      <small class="text-muted input-description">{{ description }}</small>
    </div>
    <div class="col-sm-9">
      <label class="control-label data-label" :for="fieldId">
        {{ data }}
      </label>
      <div>
        <small
          v-for="error in v.errors"
          :key="error"
          class="text-danger input-error"
          >{{ error }}</small
        >
      </div>
    </div>
  </ValidationProvider>
</template>

<script>
import Vue from "vue";
import { ValidationProvider } from "vee-validate";

export default Vue.extend({
  name: "label-field",
  components: {
    ValidationProvider
  },
  data() {
    return {};
  },
  props: {
    fieldId: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    tooltip: String,
    description: String,
    enabled: {
      type: Boolean,
      default: true
    },
    data: {
      type: String,
      required: true
    },
    value: String,
    type: {
      type: String,
      required: false,
      default: "text"
    }
  },

  computed: {
    val: {
      // getter
      get: function() {
        return this.value;
      },
      // setter
      set: function(newVal) {
        this.$emit("input", newVal);
      }
    }
  }
});
</script>

<style scoped>
.label-field {
  display: inline grid;
}

.input-description {
  text-align: right;
}

.data-label {
  font-weight: normal;
  margin-left: 5px;
}
</style>
